import type { ObjectManipulationReceipt } from '../janus-engine/actions/object-manipulation-gate';
import { ftApplyObjectManipulationReceipt } from './object-manipulation-truth.js';

export function handleObjectManipulation(receipt: ObjectManipulationReceipt): void {
    if (receipt?.schema !== 'ft.ft3d.object-manipulation.receipt.v1' || receipt.reason !== null) return;
    ftApplyObjectManipulationReceipt(receipt);
}
